// Formatters - Global utility object
window.Formatters = (function() {
  
  // Currency formatting
  const formatCurrency = (amount, currency = '€', locale = 'el-GR') => {
    if (amount === null || amount === undefined || isNaN(amount)) {
      return `0,00 ${currency}`;
    }
    
    return new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount) + ` ${currency}`;
  };

  // Date formatting
  const formatDate = (date, format = 'short') => {
    if (!date) return '';
    
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return '';
    
    const options = {
      short: { year: 'numeric', month: '2-digit', day: '2-digit' },
      long: { year: 'numeric', month: 'long', day: 'numeric' },
      medium: { year: 'numeric', month: 'short', day: 'numeric' },
      datetime: { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }
    };
    
    return dateObj.toLocaleDateString('el-GR', options[format] || options.short);
  };

  // Status colors for MUI
  const getStatusColor = (status) => {
    const statusColors = {
      paid: 'success',
      partial: 'warning',
      unpaid: 'error',
      active: 'success',
      inactive: 'default',
      pending: 'warning',
      completed: 'success',
      cancelled: 'error',
      draft: 'default',
    };
    
    return statusColors[status?.toLowerCase()] || 'default';
  };

  // Status labels in Greek
  const getStatusLabel = (status) => {
    const statusLabels = {
      paid: 'Εξοφλημένο',
      partial: 'Μερικό',
      unpaid: 'Ανεξόφλητο',
      active: 'Ενεργό',
      inactive: 'Ανενεργό',
      pending: 'Εκκρεμεί',
      completed: 'Ολοκληρωμένο',
      cancelled: 'Ακυρωμένο',
      draft: 'Πρόχειρο',
      cash: 'Μετρητά',
      bank_transfer: 'Τραπεζικό έμβασμα',
      credit_card: 'Πιστωτική κάρτα',
    };
    
    return statusLabels[status?.toLowerCase()] || status;
  };

  // Number formatting
  const formatNumber = (number, decimals = 2) => {
    if (number === null || number === undefined || isNaN(number)) {
      return '0';
    }
    
    return new Intl.NumberFormat('el-GR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(number);
  };

  return {
    formatCurrency,
    formatDate,
    getStatusColor,
    getStatusLabel,
    formatNumber,
  };
})(); 